<h1>Documents</h1>

<label for="fileUpload">Choose a File</label>
<input id="fileUpload" type="file" #upload>
<button (click)="uploadFile(upload)">Upload</button>